module.exports = __webpack_public_path__ + "img/preview.4d17c02c.svg";